import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export function MenuOptions({ name, description, to, from = '' }) {
  const history = useHistory();
  return (
    <div
      className="d-flex cursor-pointer p-2"
      to={to}
      activeClassName="areas-bg-grey"
      style={{ borderBottom: 'solid 1px #AAAAAA' }}
      onClick={() => history.push(to, { from })}
    >
      <div className="col-12 px-0" style={{ minHeight: 30 }}>
        <div className="area-card name">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="quick-user-tooltip">{name}</Tooltip>}
          >
            <h6 className="font-weight-bolder mb-0">{name}</h6>
          </OverlayTrigger>
        </div>
        <div className="area-card description">
          <div className="col-10 px-0">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="quick-user-tooltip">{description}</Tooltip>}
            >
              <span className="dark-grey">{description}</span>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </div>
  );
}
